module.exports = __webpack_public_path__ + "static/img/ALLAN_BORDER.6c9ad9a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ALLAN_BORDER.jpg
// module id = Rs0g
// module chunks = 0